import React from 'react';
import { figmaFileName } from '../../utils/figmaPaste';
import useFigmaLinkRows from '../../utils/useFigmaLinkRows';
import AeroFigmaLinkNote from './AeroFigmaLinkNote';
import AeroShareGuideModal from './AeroShareGuideModal';

const ROW = 'link';

/**
 * AeroFigmaLinkField: one Figma prototype link input with the note and the share guide under it.
 * The single-link twin of what ViewportEditor does per row, built on the same hook
 * (utils/useFigmaLinkRows.js), so Aero and Figmafolio convert, check and explain the same way.
 *
 *   value, onChange(newValue)   the link, controlled by the caller
 *   onBlur(event)               called after the link has been tidied (the caller may save a draft)
 *   disabled, autoFocus, placeholder
 *
 * Saving is never blocked by the check.
 */
export default function AeroFigmaLinkField({
  value,
  onChange,
  onBlur,
  disabled = false,
  autoFocus = false,
  placeholder = 'https://www.figma.com/proto/...',
}) {
  const link = useFigmaLinkRows({
    rows: [{ id: ROW, url: value }],
    setUrl: (_id, next) => onChange(next || ''),
    enabled: true,
  });

  return (
    <>
      <input
        className="aero-input"
        type="url"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onPaste={(e) => link.handlePaste(ROW, e)}
        onBlur={(e) => {
          link.handleBlur(ROW, e.target.value);
          if (onBlur) onBlur(e);
        }}
        disabled={disabled}
        autoFocus={autoFocus}
      />
      <AeroFigmaLinkNote
        kind={link.noteKind(ROW, value)}
        onShowHow={() => link.guide.open(ROW)}
        onRecheck={() => link.recheck(ROW, value)}
      />
      <AeroShareGuideModal
        show={link.guide.openFor !== null}
        onClose={link.guide.close}
        recheck={link.guide.recheckQuiet}
        fileName={figmaFileName(value)}
        onShared={() => {}}
      />
    </>
  );
}
